import { inject, Injectable, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_KEYS } from '@core/config/keys/cookie.keys';

@Injectable({
    providedIn: 'root'
})
export class UiService {
    /* eslint-disable @typescript-eslint/member-ordering */
    protected _sidebarOpen = signal<boolean>(false);
    sidebarOpen = this._sidebarOpen.asReadonly();
    protected cookieService = inject(CookieService);

    /* eslint-enable @typescript-eslint/member-ordering */

    constructor() {
        this.sideBarInit();
    }

    updateSidebarState() {
        this._sidebarOpen.update((s) => !s);
        this.cookieService.set(COOKIE_KEYS.SIDEBAR_STATE, JSON.stringify(this.sidebarOpen()), undefined, '/');
    }

    protected sideBarInit() {
        const sidebarState = this.getSidebarStateFromCookie();
        this._sidebarOpen.set(sidebarState);
    }

    protected getSidebarStateFromCookie(): boolean {
        const hasCookie = this.cookieService.check(COOKIE_KEYS.SIDEBAR_STATE);
        return hasCookie ? JSON.parse(this.cookieService.get(COOKIE_KEYS.SIDEBAR_STATE)) : false;
    }
}
